import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refreshCta: {
		id: 'software-code-code-page.common.error-state.refresh-cta',
		defaultMessage: 'Refresh page',
		description: 'Call to action to allow the user to refresh the page. ',
	},
});
